// Generated from the Web API by packages/api/scripts/generate.mjs. Do not edit: run `npm run api:generate`.

/**
 * The Web API operations by controller and action. `body` marks a multipart upload, and `response` a file or an
 * event stream; every other operation sends and answers JSON.
 */
export const endpoints = {
  account: {
    changeUserRole: { method: "put", path: "/api/Account/Users/{userId}/Role" },
    completeInvitation: { method: "post", path: "/api/Account/Users/Invitations/{id}/Complete" },
    deleteInvitation: { method: "delete", path: "/api/Account/Users/Invitations/{id}" },
    deleteProfilePicture: { method: "delete", path: "/api/Account/Users/ProfilePicture" },
    exchangeForToken: { method: "get", path: "/api/Account/Token" },
    getInvitationsForOrganization: { method: "get", path: "/api/Account/Users/Invitations" },
    getMyPermissions: { method: "get", path: "/api/Account/Users/Me/Permissions" },
    getUser: { method: "get", path: "/api/Account/Users/Profile" },
    getUsersForOrganization: { method: "get", path: "/api/Account/Users" },
    inviteUser: { method: "post", path: "/api/Account/Users/Invitations" },
    onboarding: { method: "post", path: "/api/Account/Onboarding" },
    preValidateInvitation: { method: "get", path: "/api/Account/Users/Invitations/{id}/PreValidate" },
    removeUserFromOrganization: { method: "delete", path: "/api/Account/Users/{userId}" },
    requestChangePassword: { method: "get", path: "/api/Account/Users/ResetPassword" },
    requestEmailConfirmation: { method: "get", path: "/api/Account/RequestEmailConfirmation" },
    resendInvite: { method: "put", path: "/api/Account/Users/Invitations/{id}/Resend" },
    updateUser: { method: "put", path: "/api/Account/Users/Profile" },
    uploadProfilePicture: { method: "put", path: "/api/Account/Users/ProfilePicture", body: "multipart" },
  },
  automation: {
    create: { method: "post", path: "/api/JobPostings/{jobId}/Automation/Rules" },
    createOrg: { method: "post", path: "/api/Automation/Rules" },
    delete: { method: "delete", path: "/api/JobPostings/{jobId}/Automation/Rules/{ruleId}" },
    deleteOrg: { method: "delete", path: "/api/Automation/Rules/{ruleId}" },
    disable: { method: "post", path: "/api/JobPostings/{jobId}/Automation/Rules/{ruleId}/Disable" },
    disableOrg: { method: "post", path: "/api/Automation/Rules/{ruleId}/Disable" },
    dryRun: { method: "post", path: "/api/JobPostings/{jobId}/Automation/Rules/{ruleId}/DryRun" },
    dryRunOrg: { method: "post", path: "/api/Automation/Rules/{ruleId}/DryRun" },
    enable: { method: "post", path: "/api/JobPostings/{jobId}/Automation/Rules/{ruleId}/Enable" },
    enableOrg: { method: "post", path: "/api/Automation/Rules/{ruleId}/Enable" },
    get: { method: "get", path: "/api/JobPostings/{jobId}/Automation/Rules/{ruleId}" },
    getAcknowledgment: { method: "get", path: "/api/Automation/Acknowledgment" },
    getCandidateActivity: { method: "get", path: "/api/JobPostings/{jobId}/Automation/Candidates/{mappingId}/Activity" },
    getExecutions: { method: "get", path: "/api/JobPostings/{jobId}/Automation/Rules/{ruleId}/Executions" },
    getOrg: { method: "get", path: "/api/Automation/Rules/{ruleId}" },
    getOrgExecutions: { method: "get", path: "/api/Automation/Rules/{ruleId}/Executions" },
    getRecentEvents: { method: "get", path: "/api/Automation/Events/Recent" },
    getRecentRuns: { method: "get", path: "/api/Automation/Executions" },
    getRegistry: { method: "get", path: "/api/Automation/Registry" },
    list: { method: "get", path: "/api/JobPostings/{jobId}/Automation/Rules" },
    listOrg: { method: "get", path: "/api/Automation/Rules" },
    reorder: { method: "put", path: "/api/Automation/Rules/Order" },
    reset: { method: "post", path: "/api/JobPostings/{jobId}/Automation/Rules/{ruleId}/Reset" },
    resetOrg: { method: "post", path: "/api/Automation/Rules/{ruleId}/Reset" },
    run: { method: "post", path: "/api/JobPostings/{jobId}/Automation/Rules/{ruleId}/Run" },
    runOrg: { method: "post", path: "/api/Automation/Rules/{ruleId}/Run" },
    update: { method: "put", path: "/api/JobPostings/{jobId}/Automation/Rules/{ruleId}" },
    updateOrg: { method: "put", path: "/api/Automation/Rules/{ruleId}" },
  },
  billing: {
    cancelSubscription: { method: "post", path: "/api/billing/cancel" },
    createPortalSession: { method: "post", path: "/api/billing/portal-session" },
    getInterviewOptions: { method: "get", path: "/api/billing/interview-options" },
    getInvoices: { method: "get", path: "/api/billing/invoices" },
    getOrgBillingStatus: { method: "get", path: "/api/billing/org-status" },
    getPaymentMethod: { method: "get", path: "/api/billing/payment-method" },
    getStripeProducts: { method: "get", path: "/api/billing/products" },
    grantEventsTrial: { method: "post", path: "/api/billing/grant-events-trial" },
    healthCheck: { method: "get", path: "/api/billing/health" },
    previewCoupon: { method: "post", path: "/api/billing/coupons/preview" },
    purchaseCredits: { method: "post", path: "/api/billing/purchase-credits" },
    reactivateSubscription: { method: "post", path: "/api/billing/reactivate" },
    redeemCoupon: { method: "post", path: "/api/billing/coupons/redeem" },
    subscribe: { method: "post", path: "/api/billing/subscribe" },
    updatePaymentMethod: { method: "post", path: "/api/billing/update-payment-method" },
  },
  candidates: {
    applyOrBulkApply: { method: "post", path: "/api/Candidates/{jobId}/ApplyOrBulkApply", body: "multipart" },
    bulkAddComments: { method: "post", path: "/api/Candidates/Comments/Bulk" },
    bulkUpdateCandidateStage: { method: "put", path: "/api/Candidates/{jobId}/BulkUpdateCandidateStage" },
    compareCandidates: { method: "get", path: "/api/Candidates/{jobId}/Compare" },
    createComment: { method: "post", path: "/api/Candidates/Comments" },
    delete: { method: "delete", path: "/api/Candidates/{candidateId}" },
    deleteCandidateRiskItem: { method: "delete", path: "/api/Candidates/{riskId}/RiskItem" },
    deleteComment: { method: "delete", path: "/api/Candidates/Comments/{commentId}" },
    dismissIntakeFileFailure: { method: "delete", path: "/api/Candidates/{jobId}/IntakeQueue/Files/{failureId}" },
    evaluateTool: { method: "post", path: "/api/Candidates/{jobId}/{candidateId}/evaluate-tool" },
    filterCandidates: { method: "post", path: "/api/Candidates/FilterCandidates" },
    filterCandidatesAdvanced: { method: "post", path: "/api/Candidates/AdvancedFilter" },
    generateCandidateReport: { method: "post", path: "/api/Candidates/{jobId}/{candidateId}/Report/Generate" },
    getAdvancedFilterOption: { method: "get", path: "/api/Candidates/{jobId}/AdvancedFilter/SelectionData" },
    getAggregatedScorecard: { method: "get", path: "/api/Candidates/{jobId}/{candidateId}/AggregatedScorecard" },
    getCandidateConsentStatus: { method: "get", path: "/api/Candidates/Consents/{candidateId}/Status" },
    getCandidateConsents: { method: "get", path: "/api/Candidates/Consents/{candidateId}" },
    getCandidateDetails: { method: "get", path: "/api/Candidates/{jobId}/{candidateId}/Details" },
    getCandidateInsights: { method: "get", path: "/api/Candidates/{jobId}/{candidateId}/Insights" },
    getCandidateIntegrity: { method: "get", path: "/api/Candidates/{jobId}/{candidateId}/Integrity" },
    getCandidateOverview: { method: "get", path: "/api/Candidates/{jobId}/{candidateId}/Overview" },
    getCandidateRequirements: { method: "get", path: "/api/Candidates/{jobId}/{candidateId}/Requirements" },
    getCandidateRiskDetails: { method: "get", path: "/api/Candidates/{jobId}/{candidateId}/DetailedRisk" },
    getCandidateRoundDetail: { method: "get", path: "/api/Candidates/{jobId}/{candidateId}/RoundDetail/{interviewId}" },
    getCandidateScoreCardDetails: { method: "get", path: "/api/Candidates/{jobId}/{candidateId}/DetailedScoreCard" },
    getCandidatesBasedOnQuery: { method: "post", path: "/api/Candidates/QueryCandidates" },
    getCandidatesByJobAndWorkflowStageGroup: { method: "get", path: "/api/Candidates/{jobId}/{workflowStageGroup}" },
    getComments: { method: "get", path: "/api/Candidates/{jobId}/{candidateId}/Comments" },
    getHireDecisions: { method: "post", path: "/api/Candidates/HireDecisions" },
    getIntakeQueue: { method: "get", path: "/api/Candidates/{jobId}/IntakeQueue/{status}" },
    getIntakeQueueCounts: { method: "get", path: "/api/Candidates/{jobId}/IntakeQueue/Counts" },
    getRejectedCandidates: { method: "get", path: "/api/Candidates/{jobId}/{stageId}/Rejected" },
    getStageCandidateCounts: { method: "post", path: "/api/Candidates/{jobId}/StageCounts" },
    removeFailedApplication: { method: "delete", path: "/api/Candidates/{jobId}/IntakeQueue/{mappingId}" },
    resolveCandidateInsight: { method: "put", path: "/api/Candidates/{insightId}/InsightResolve" },
    retryIntake: { method: "post", path: "/api/Candidates/{jobId}/IntakeQueue/{mappingId}/Retry" },
    reviewCandidateIntegrity: { method: "post", path: "/api/Candidates/{jobId}/{candidateId}/Integrity/{interviewId}/Review" },
    updateCandidateRiskItem: { method: "put", path: "/api/Candidates/{riskId}/RiskItem" },
    updateCandidateStage: { method: "put", path: "/api/Candidates/UpdateCandidateStage" },
    updateComment: { method: "put", path: "/api/Candidates/Comments/{commentId}" },
  },
  emailMessages: {
    delete: { method: "delete", path: "/api/EmailMessages" },
    downloadAttachment: { method: "get", path: "/api/EmailMessages/Attachments/{attachmentId}/Download", response: "file" },
    getBatchHistory: { method: "get", path: "/api/EmailMessages/History/Batch" },
    getCandidateHistory: { method: "get", path: "/api/EmailMessages/History/Applicants" },
    markRead: { method: "post", path: "/api/EmailMessages/MarkRead" },
    sendBatch: { method: "post", path: "/api/EmailMessages/SendBatch" },
    uploadAttachment: { method: "post", path: "/api/EmailMessages/Attachments", body: "multipart" },
  },
  emailTemplates: {
    create: { method: "post", path: "/api/EmailTemplates" },
    delete: { method: "delete", path: "/api/EmailTemplates/{id}" },
    get: { method: "get", path: "/api/EmailTemplates/{id}" },
    getTemplates: { method: "get", path: "/api/EmailTemplates" },
    update: { method: "put", path: "/api/EmailTemplates/{id}" },
  },
  forms: {
    attachToJob: { method: "post", path: "/api/Forms/{templateFormId}/Jobs/{jobPostingId}" },
    create: { method: "post", path: "/api/Forms" },
    delete: { method: "delete", path: "/api/Forms/{formId}" },
    discardDraft: { method: "delete", path: "/api/Forms/{formId}/Draft" },
    ensureJobApplicationForm: { method: "post", path: "/api/Forms/Jobs/{jobPostingId}/ApplicationForm" },
    get: { method: "get", path: "/api/Forms/{formId}" },
    getAttachedForm: { method: "get", path: "/api/Forms/Jobs/{jobPostingId}/Form" },
    getDraft: { method: "get", path: "/api/Forms/{formId}/Draft" },
    getJobFilterFields: { method: "get", path: "/api/Forms/Jobs/{jobPostingId}/FilterFields" },
    getJobPublishedDefinition: { method: "get", path: "/api/Forms/Jobs/{jobPostingId}" },
    getPublished: { method: "get", path: "/api/Forms/{formId}/Published" },
    getSubmission: { method: "get", path: "/api/Forms/Applications/{jobPostingCandidateMappingId}/Submission" },
    getTemplates: { method: "get", path: "/api/Forms/Templates" },
    getVersionDefinition: { method: "get", path: "/api/Forms/Versions/{formVersionId}" },
    publishDraft: { method: "post", path: "/api/Forms/{formId}/Draft/Publish" },
    saveDraft: { method: "put", path: "/api/Forms/{formId}/Draft" },
    setDefaultTemplate: { method: "put", path: "/api/Forms/{formId}/Default" },
    update: { method: "put", path: "/api/Forms/{formId}" },
  },
  integrations: {
    createFreshteamIntegration: { method: "post", path: "/api/Integrations/Active/Freshteam" },
    deleteFreshteamIntegration: { method: "delete", path: "/api/Integrations/Active/Freshteam/{id}" },
    getByOrganizationId: { method: "get", path: "/api/Integrations/Available" },
    getFreshteamIntegration: { method: "get", path: "/api/Integrations/Active/Freshteam/{id}" },
    updateFreshteamIntegration: { method: "put", path: "/api/Integrations/Active/Freshteam/{id}" },
  },
  intercomMessenger: {
    get: { method: "get", path: "/api/Account/Users/IntercomMessenger" },
  },
  interview: {
    appendSessionEvents: { method: "post", path: "/api/Interview/{interviewId}/Session/Events" },
    cancelInterview: { method: "put", path: "/api/Interview/{interviewId}/Cancel" },
    downloadAssessmentSubmissionZip: { method: "get", path: "/api/Interview/{interviewId}/AssessmentSubmission/Download", response: "file" },
    getAssessmentSubmission: { method: "get", path: "/api/Interview/{interviewId}/AssessmentSubmission" },
    getCandidateInterviewDetails: { method: "get", path: "/api/Interview/{jobId}/{candidateId}/{status}/CandidateInterviewDetails" },
    getCandidateInterviewRounds: { method: "get", path: "/api/Interview/{jobId}/{candidateId}/Rounds" },
    getCriteriaEvaluated: { method: "get", path: "/api/Interview/{interviewId}/DetailedScoreCard" },
    getHumanRounds: { method: "get", path: "/api/Interview/{jobId}/HumanRounds" },
    getInterviewDetails: { method: "get", path: "/api/Interview/Details" },
    getInterviewDetailsById: { method: "get", path: "/api/Interview/{interviewId}/Details" },
    getJobInterviewCandidates: { method: "get", path: "/api/Interview/{jobId}" },
    getLatestInterviewAnalysis: { method: "get", path: "/api/Interview/{jobId}/{candidateId}/Analysis" },
    getPromptingAnalysis: { method: "get", path: "/api/Interview/{interviewId}/AssessmentSubmission/PromptingAnalysis" },
    getResumeScoreCard: { method: "get", path: "/api/Interview/{jobId}/{candidateId}/ResumeScoreCard" },
    getSessionReplay: { method: "get", path: "/api/Interview/{interviewId}/SessionReplay" },
    initiatePhoneScreen: { method: "post", path: "/api/Interview/PhoneScreen/Initiate" },
    requestFollowUpCalls: { method: "post", path: "/api/Interview/FollowUpCall/Request" },
    sendEncodedLink: { method: "post", path: "/api/Interview/SendEncodedLink" },
    startInterview: { method: "post", path: "/api/Interview/Start" },
    submitFeedback: { method: "post", path: "/api/Interview/Feedback" },
    submitManualScore: { method: "post", path: "/api/Interview/{jobId}/{candidateId}/ManualScore" },
    updateInterviewExpiry: { method: "put", path: "/api/Interview/{interviewId}/UpdateExpiry" },
  },
  interviewAgents: {
    create: { method: "post", path: "/api/InterviewAgents" },
    delete: { method: "delete", path: "/api/InterviewAgents/{agentId}" },
    deleteProfilePicture: { method: "delete", path: "/api/InterviewAgents/{agentId}/ProfilePicture" },
    get: { method: "get", path: "/api/InterviewAgents/{agentId}" },
    getAll: { method: "get", path: "/api/InterviewAgents" },
    update: { method: "put", path: "/api/InterviewAgents/{agentId}" },
    uploadProfilePicture: { method: "put", path: "/api/InterviewAgents/{agentId}/ProfilePicture", body: "multipart" },
  },
  interviewPlans: {
    create: { method: "post", path: "/api/InterviewPlans" },
    createQuestion: { method: "post", path: "/api/InterviewPlans/questions" },
    delete: { method: "delete", path: "/api/InterviewPlans/{id}" },
    deleteQuestion: { method: "delete", path: "/api/InterviewPlans/questions/{questionId}" },
    get: { method: "get", path: "/api/InterviewPlans/{id}" },
    getByJobPosting: { method: "get", path: "/api/InterviewPlans/jobPostings/{jobPostingId}" },
    getQuestion: { method: "get", path: "/api/InterviewPlans/questions/{questionId}" },
    getQuestions: { method: "get", path: "/api/InterviewPlans/{interviewPlanId}/questions" },
    getSummariesByJobPosting: { method: "get", path: "/api/InterviewPlans/jobPostings/{jobPostingId}/summaries" },
    process: { method: "post", path: "/api/InterviewPlans/{id}/process" },
    reorderQuestions: { method: "put", path: "/api/InterviewPlans/{interviewPlanId}/questions/reorder" },
    update: { method: "put", path: "/api/InterviewPlans" },
    updateQuestion: { method: "put", path: "/api/InterviewPlans/questions/{questionId}" },
  },
  jobInviteEmails: {
    deleteMain: { method: "delete", path: "/api/JobPostings/{jobId}/InviteEmails/Main" },
    deleteRound: { method: "delete", path: "/api/JobPostings/{jobId}/InviteEmails/Rounds/{interviewPlanId}" },
    get: { method: "get", path: "/api/JobPostings/{jobId}/InviteEmails" },
    preview: { method: "post", path: "/api/JobPostings/{jobId}/InviteEmails/Preview" },
    saveMain: { method: "put", path: "/api/JobPostings/{jobId}/InviteEmails/Main" },
    saveRound: { method: "put", path: "/api/JobPostings/{jobId}/InviteEmails/Rounds/{interviewPlanId}" },
  },
  jobPostingFollowers: {
    follow: { method: "post", path: "/api/JobPostings/{jobId}/Followers" },
    getFollowers: { method: "get", path: "/api/JobPostings/{jobId}/Followers" },
    getMyFollowedJobs: { method: "get", path: "/api/JobPostings/Followers/Mine" },
    isFollowing: { method: "get", path: "/api/JobPostings/{jobId}/Followers/Me" },
    unfollow: { method: "delete", path: "/api/JobPostings/{jobId}/Followers/Me" },
  },
  jobPostings: {
    addInterviewAgenda: { method: "post", path: "/api/JobPostings/InterviewAgenda" },
    createFilterForJob: { method: "post", path: "/api/JobPostings/Filters" },
    createJobPosting: { method: "post", path: "/api/JobPostings" },
    createJobPostingCriteria: { method: "post", path: "/api/JobPostings/{jobId}/Criteria" },
    delete: { method: "delete", path: "/api/JobPostings/{id}" },
    deleteFilterForJob: { method: "delete", path: "/api/JobPostings/Filters/{filterId}" },
    deleteInterviewAgenda: { method: "delete", path: "/api/JobPostings/InterviewAgenda/{agendaId}" },
    deleteJobPostingCriterion: { method: "delete", path: "/api/JobPostings/Criteria/{criterionId}" },
    deleteWorkflowStage: { method: "delete", path: "/api/JobPostings/{jobId}/WorkflowStages/{stageId}" },
    fixJobDescriptionWithChecklist: { method: "post", path: "/api/JobPostings/FixJobDescriptionWithChecklist" },
    generateDuplicateJobPosting: { method: "post", path: "/api/JobPostings/{jobId}/Duplicate" },
    generateJobDescription: { method: "post", path: "/api/JobPostings/{jobId}/GenerateJobDescription" },
    generateJobDescriptionWithText: { method: "post", path: "/api/JobPostings/{jobId}/GenerateJobDescriptionWithText" },
    get: { method: "get", path: "/api/JobPostings/{id}" },
    getAiParseJobData: { method: "get", path: "/api/JobPostings/{jobId}/Ai/Parse" },
    getCandidatesBasedOnQuery: { method: "post", path: "/api/JobPostings/QueryJobs" },
    getCandidatesForJob: { method: "get", path: "/api/JobPostings/{jobId}/candidates" },
    getFiltersForJob: { method: "get", path: "/api/JobPostings/{jobId}/Filters" },
    getInterviewAgenda: { method: "get", path: "/api/JobPostings/{jobId}/InterviewAgenda" },
    getJobChecklists: { method: "get", path: "/api/JobPostings/JobChecklists" },
    getJobDetails: { method: "get", path: "/api/JobPostings/{jobId}/Details" },
    getJobPostingCriteria: { method: "get", path: "/api/JobPostings/{jobId}/Criteria" },
    getJobPostings: { method: "get", path: "/api/JobPostings" },
    getWorkflowStagesByWorkflowId: { method: "get", path: "/api/JobPostings/{jobId}/WorkflowStages" },
    parseJobChecklist: { method: "post", path: "/api/JobPostings/ParseJobChecklist" },
    parseJobPostingCriteria: { method: "post", path: "/api/JobPostings/ParseJobPostingCriteria" },
    processContentWithAi: { method: "post", path: "/api/JobPostings/ProcessContent" },
    update: { method: "put", path: "/api/JobPostings/{jobId}/update" },
    updateFilterForJob: { method: "put", path: "/api/JobPostings/Filters/{filterId}" },
    updateInterviewAgenda: { method: "put", path: "/api/JobPostings/InterviewAgenda/{agendaId}" },
    updateJobPostingCriterion: { method: "put", path: "/api/JobPostings/Criteria/{criterionId}" },
    updateWorkflowStagesOrder: { method: "put", path: "/api/JobPostings/{jobId}/WorkflowStages" },
  },
  jobReports: {
    getBusinessImpact: { method: "get", path: "/api/JobPostings/{jobId}/Reports/BusinessImpact" },
    getHiringFunnel: { method: "get", path: "/api/JobPostings/{jobId}/Reports/HiringFunnel" },
  },
  jobSettings: {
    createRule: { method: "post", path: "/api/JobPostings/{jobId}/AutomationRules" },
    deleteRule: { method: "delete", path: "/api/JobPostings/{jobId}/AutomationRules/{ruleId}" },
    getSettings: { method: "get", path: "/api/JobPostings/{jobId}/Settings" },
    revertSetting: { method: "delete", path: "/api/JobPostings/{jobId}/Settings/{key}" },
    setSetting: { method: "put", path: "/api/JobPostings/{jobId}/Settings/{key}" },
    updateRule: { method: "put", path: "/api/JobPostings/{jobId}/AutomationRules/{ruleId}" },
  },
  organizationRag: {
    addLink: { method: "post", path: "/api/OrganizationRag/AddLink" },
    addQAEntries: { method: "post", path: "/api/OrganizationRag/AddQA" },
    approveEssentialAnswer: { method: "post", path: "/api/OrganizationRag/essentials/{questionKey}/approve" },
    deleteEssentialAnswer: { method: "delete", path: "/api/OrganizationRag/essentials/{questionKey}/answer" },
    deleteTrainingSource: { method: "delete", path: "/api/OrganizationRag/sources/{id}" },
    getEssentialQuestionCatalog: { method: "get", path: "/api/OrganizationRag/essentials/catalog" },
    getEssentialsReadiness: { method: "get", path: "/api/OrganizationRag/essentials" },
    getTrainingSource: { method: "get", path: "/api/OrganizationRag/Sources/{id}" },
    getTrainingSources: { method: "get", path: "/api/OrganizationRag/Sources" },
    initializeRagStore: { method: "post", path: "/api/OrganizationRag/Initialize" },
    queryRagStore: { method: "post", path: "/api/OrganizationRag/Query" },
    queryRagStoreStream: { method: "post", path: "/api/OrganizationRag/Query/Stream", response: "stream" },
    rescanSource: { method: "post", path: "/api/OrganizationRag/sources/{id}/rescan" },
    reuploadSource: { method: "post", path: "/api/OrganizationRag/sources/{id}/reupload", body: "multipart" },
    setSourceAutoSync: { method: "put", path: "/api/OrganizationRag/sources/{id}/auto-sync" },
    uploadDocument: { method: "post", path: "/api/OrganizationRag/UploadDocument", body: "multipart" },
    upsertEssentialAnswer: { method: "put", path: "/api/OrganizationRag/essentials/{questionKey}/answer" },
  },
  organizations: {
    checkIfSlugTaken: { method: "get", path: "/api/Organizations/{id}/Slug" },
    createOrganizationGeminiFileSearchStore: { method: "post", path: "/api/Organizations/GeminiFileSearchStore" },
    deleteDefaultWorkflowStage: { method: "delete", path: "/api/Organizations/{id}/WorkflowStages/{stageId}" },
    deleteOrganizationLogo: { method: "delete", path: "/api/Organizations/{id}/Logo" },
    ensureEmbedBoard: { method: "post", path: "/api/Organizations/{id}/EmbedBoard" },
    getDefaultWorkflowStages: { method: "get", path: "/api/Organizations/{id}/WorkflowStages" },
    getOrganization: { method: "get", path: "/api/Organizations/{id}" },
    getOrganizationLogo: { method: "get", path: "/api/Organizations/{id}/Logo", response: "file" },
    getVoiceAgentConfiguration: { method: "get", path: "/api/Organizations/{id}/VoiceAgent" },
    update: { method: "put", path: "/api/Organizations/{id}" },
    updateDefaultWorkflowStages: { method: "put", path: "/api/Organizations/{id}/WorkflowStages" },
    updateEmbedBoard: { method: "put", path: "/api/Organizations/{id}/EmbedBoard" },
    updateVoiceAgentConfiguration: { method: "put", path: "/api/Organizations/{id}/VoiceAgent" },
    uploadOrganizationLogo: { method: "put", path: "/api/Organizations/{id}/Logo", body: "multipart" },
  },
  ping: {
    ping: { method: "get", path: "/api/Ping" },
  },
  public: {
    candidates: { method: "post", path: "/api/Public/{jobSlug}/Candidate/Apply", body: "multipart" },
    declineFollowUpCall: { method: "post", path: "/api/Public/CandidateTakeHome/FollowUpCall/Decline" },
    getApplicationForm: { method: "get", path: "/api/Public/{jobSlug}/ApplicationForm" },
    getAssessmentAiBudget: { method: "get", path: "/api/Public/CandidateTakeHome/AiBudget" },
    getAssessmentAiInstallScript: { method: "get", path: "/api/Public/CandidateTakeHome/InstallScript", response: "file" },
    getCandidatePortal: { method: "get", path: "/api/Public/CandidatePortal" },
    getCandidatePortalIds: { method: "get", path: "/api/Public/CandidatePortalIds" },
    getCandidatePortalRounds: { method: "get", path: "/api/Public/CandidatePortal/Rounds" },
    getCandidateTakeHome: { method: "get", path: "/api/Public/CandidateTakeHome" },
    getCandidateTakeHomeHarnessConfig: { method: "get", path: "/api/Public/CandidateTakeHome/HarnessConfig", response: "file" },
    getCandidateTakeHomeHarnessPlugin: { method: "get", path: "/api/Public/CandidateTakeHome/HarnessPlugin", response: "file" },
    getCandidateTakeHomeProblemStatement: { method: "get", path: "/api/Public/CandidateTakeHome/ProblemStatement", response: "file" },
    getCandidateTakeHomeStatus: { method: "get", path: "/api/Public/CandidateTakeHome/Submission/Status" },
    getCandidateTakeHomeTimer: { method: "get", path: "/api/Public/CandidateTakeHome/Timer" },
    getFollowUpCallCodingSessions: { method: "get", path: "/api/Public/CandidateTakeHome/FollowUpCall/CodingSessions" },
    getFollowUpCallFileContent: { method: "get", path: "/api/Public/CandidateTakeHome/FollowUpCall/FileContent", response: "file" },
    getFollowUpCallFiles: { method: "get", path: "/api/Public/CandidateTakeHome/FollowUpCall/Files" },
    getJobBoard: { method: "get", path: "/api/Public/Board/{boardId}" },
    getJobBoardFramePolicy: { method: "get", path: "/api/Public/Board/{boardId}/FramePolicy" },
    getJobs: { method: "get", path: "/api/Public/Jobs" },
    getOrganizationDetail: { method: "get", path: "/api/Public/{orgSlug}/OrganizationDetail" },
    launchCandidatePortalRound: { method: "post", path: "/api/Public/CandidatePortal/Rounds/{roundId}/Launch" },
    provisionAssessmentAi: { method: "post", path: "/api/Public/CandidateTakeHome/Provision" },
    reportAssessmentScriptError: { method: "post", path: "/api/Public/CandidateTakeHome/ScriptError" },
    startCandidateTakeHomeTimer: { method: "post", path: "/api/Public/CandidateTakeHome/Timer/Start" },
    submitCandidateTakeHome: { method: "post", path: "/api/Public/CandidateTakeHome/Submission", body: "multipart" },
  },
  scheduledRejections: {
    cancel: { method: "post", path: "/api/ScheduledRejections/{id}/Cancel" },
    get: { method: "get", path: "/api/ScheduledRejections" },
    queue: { method: "post", path: "/api/ScheduledRejections" },
    sendNow: { method: "post", path: "/api/ScheduledRejections/{id}/SendNow" },
  },
  userNotificationPreferences: {
    get: { method: "get", path: "/api/Account/Users/NotificationPreferences" },
    seedTimezone: { method: "put", path: "/api/Account/Users/NotificationPreferences/Timezone" },
    update: { method: "put", path: "/api/Account/Users/NotificationPreferences" },
  },
  workflowDraft: {
    addNewStageDraft: { method: "post", path: "/api/WorkflowDraft/jobPostings/{jobPostingId}/workflow/stages/draft" },
    checkFlowStep: { method: "post", path: "/api/WorkflowDraft/jobPostings/{jobPostingId}/workflow/plan/flow/{step}/check" },
    createPlanDraftOnPublishedStage: { method: "post", path: "/api/WorkflowDraft/jobPostings/{jobPostingId}/workflow/stages/{publishedStageId}/plan/draft" },
    deletePlanDraft: { method: "delete", path: "/api/WorkflowDraft/jobPostings/{jobPostingId}/workflow/plan/draft" },
    deleteStageDraft: { method: "delete", path: "/api/WorkflowDraft/jobPostings/{jobPostingId}/workflow/stages/draft" },
    discard: { method: "post", path: "/api/WorkflowDraft/jobPostings/{jobPostingId}/workflow/discard" },
    generateQuestions: { method: "post", path: "/api/WorkflowDraft/jobPostings/{jobPostingId}/workflow/plan/questions/generate", response: "stream" },
    getEditorState: { method: "get", path: "/api/WorkflowDraft/jobPostings/{jobPostingId}/workflow/editor" },
    hasDraft: { method: "get", path: "/api/WorkflowDraft/jobPostings/{jobPostingId}/workflow/has-draft" },
    publish: { method: "post", path: "/api/WorkflowDraft/jobPostings/{jobPostingId}/workflow/publish" },
    reorderStages: { method: "put", path: "/api/WorkflowDraft/jobPostings/{jobPostingId}/workflow/stages/draft/reorder" },
    saveNewStagePlanDraft: { method: "put", path: "/api/WorkflowDraft/jobPostings/{jobPostingId}/workflow/stages/draft/{stageDraftId}/plan" },
    savePlanDraft: { method: "put", path: "/api/WorkflowDraft/jobPostings/{jobPostingId}/workflow/stages/{publishedStageId}/plan/{publishedPlanId}/draft" },
    saveStageDraft: { method: "put", path: "/api/WorkflowDraft/jobPostings/{jobPostingId}/workflow/stages/{publishedStageId}/draft" },
    updateDraftOnlyPlan: { method: "put", path: "/api/WorkflowDraft/jobPostings/{jobPostingId}/workflow/plan/draft/{draftPlanId}" },
  },
} as const;
